import { InjectionToken } from "@angular/core";
import { PhxOptionComponent } from "./option.component";

export const PHX_SELECT_OPTION_TOKEN = new InjectionToken<PhxOptionComponent>(
  'phx-select-option'
);